import { createTheme } from '@mui/material/styles';
import tokens from './tokens';

const muiTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: tokens.colors.primary,
            dark: tokens.colors.primaryDark,
        },
        secondary: {
            main: '#116466',
        },
        success: {
            main: tokens.colors.success,
        },
        warning: {
            main: tokens.colors.warning,
        },
        error: {
            main: tokens.colors.error,
        },
        info: {
            main: tokens.colors.info,
        },
        text: {
            primary: tokens.colors.text,
            secondary: tokens.colors.muted,
        },
        background: {
            default: tokens.colors.bg,
            paper: tokens.colors.surface,
        },
        divider: tokens.colors.border,
    },
    shape: {
        borderRadius: tokens.radius.md,
    },
    typography: {
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif',
        h1: {
            fontSize: '2rem',
            fontWeight: 700,
            letterSpacing: '-0.02em',
        },
        h2: {
            fontSize: '1.35rem',
            fontWeight: 600,
            letterSpacing: '-0.01em',
        },
        button: {
            textTransform: 'none',
            fontWeight: 600,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: tokens.radius.sm,
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: tokens.radius.lg,
                    boxShadow: tokens.shadows.md,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: tokens.radius.lg,
                    boxShadow: tokens.shadows.md,
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: tokens.radius.sm,
                },
            },
        },
    },
    customTokens: tokens,
});

export default muiTheme;
